export enum StatusEnum {
  INTRODUCED = 'INTRODUCED',
  PASSED_ONE_CHAMBER = 'PASSED_ONE_CHAMBER',
  PASSED_BOTH_CHAMBERS = 'PASSED_BOTH_CHAMBERS',
  ENACTED = 'ENACTED',
  FAILED = 'FAILED',
  VETOED = 'VETOED',
}
